import { render } from "./ItemProfileOfferList.vue?vue&type=template&id=68b02468&scoped=true"
import script from "./ItemProfileOfferList.vue?vue&type=script&lang=ts"
export * from "./ItemProfileOfferList.vue?vue&type=script&lang=ts"

import "./ItemProfileOfferList.vue?vue&type=style&index=0&id=68b02468&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68b02468"

export default script